import { render } from "./Univ.vue?vue&type=template&id=329ec7d4&scoped=true"
import script from "./Univ.vue?vue&type=script&lang=js"
export * from "./Univ.vue?vue&type=script&lang=js"

import "./Univ.vue?vue&type=style&index=0&id=329ec7d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-329ec7d4"

export default script